<div class="scroll-y">
  <table
    class="table table-row-bordered align-middle gy-4 text-dark"
    [ngClass]="tableClasses"
  >
    <thead>
      <tr class="fw-normal fs-8 text-uppercase" [ngClass]="headerClasses">
        <th
          *ngFor="let column of columns"
          class="table-header text-nowrap cursor-default {{column.headerClass}}"
        >
          <ng-container
            *ngIf="column?.headerType === tableColumnHeaderType.CUSTOM"
            [ngTemplateOutlet]="column | appGetCustomTemplate:customHeaderTemplates"
            [ngTemplateOutletContext] ="{ $implicit: column, data: column }"
          >
          </ng-container>
          <span *ngIf="column?.headerType !== tableColumnHeaderType.CUSTOM">
            {{ column.label | translate }}
          </span>
        </th>
      </tr>
    </thead>
    <ng-container *ngIf="draggable; else notDraggableList">
      <tbody cdkDropList (cdkDropListDropped)="onDrop($event)" class="fw-normal fs-6 border-top-1">
        <tr
          *ngFor="let row of rows  | appOrderBy:'feedCpcRuleDto':'priority':!draggable"
          [ngClass]="rowClassesFn?.(row)"
          cdkDrag cdkDragLockAxis='y'
        >
        <td *ngFor="let column of columns; let first=first" class="table-column {{column.cellClass}}"  [attr.test-id]="column.name">
            <div *ngIf="first" cdkDragHandle class="right-border">
              <i class="bi bi-chevron-bar-expand fs-3 handle"></i>
            </div>
            <span *ngIf="column?.type === tableColumnType.CURRENCY">
              {{ row | appGetColumnValue:column | appCurrency }}
            </span>
            <ng-container
              *ngIf="column?.type === tableColumnType.CUSTOM"
              [ngTemplateOutlet]="column | appGetCustomTemplate:customTemplates"
              [ngTemplateOutletContext] ="{ $implicit: row, data: row }"
            ></ng-container>
            <div style="min-width: 120px">
              <span *ngIf="!column?.type && column.label !== 'CAMPAIGNS.LIST.ID'">
                {{ row | appGetColumnValue:column | numberWithSpaces }}
              </span>
            </div>

            <span *ngIf="!column?.type && column.label === 'CAMPAIGNS.LIST.ID'">
              {{ row | appGetColumnValue:column }}
            </span>
          </td>

        </tr>
        <tr *ngIf="!rows.length">
          <td [attr.colspan]="columns.length" class="text-center fw-bold fs-6">
            <ng-container *ngIf="noDataTemplate" [ngTemplateOutlet]="noDataTemplate"></ng-container>
            <span *ngIf="!noDataTemplate">
              {{ 'TABLE.EMPTY' | translate }}
            </span>
          </td>
        </tr>
      </tbody>
    </ng-container>
    <ng-template #notDraggableList>
      <tbody class="fw-normal fs-6 border-top-1">
        <tr
          *ngFor="let row of rows"
          [ngClass]="rowClassesFn?.(row)"
        >
          <td *ngFor="let column of columns" class="table-column {{column.cellClass}}" [attr.test-id]="column.name">
            <span *ngIf="column?.type === tableColumnType.TEXT" >
              {{ row | appGetColumnValue:column }}
            </span>
            <span *ngIf="column?.type === tableColumnType.CURRENCY" >
              {{ row | appGetColumnValue:column | appCurrency }}
            </span>
            <ng-container *ngIf="column?.type === tableColumnType.CUSTOM"
              [ngTemplateOutlet]="column | appGetCustomTemplate:customTemplates"
              [ngTemplateOutletContext] ="{ $implicit: row, data: row }">
            </ng-container>
            <div style="min-width: 120px">
              <span *ngIf="!column?.type && column.label !== 'CAMPAIGNS.LIST.ID'">
                {{ row | appGetColumnValue:column | numberWithSpaces }}
              </span>
            </div>
            <span *ngIf="!column?.type && column.label === 'CAMPAIGNS.LIST.ID'">
              {{ row | appGetColumnValue:column }}
            </span>
          </td>
        </tr>
      </tbody>
    </ng-template>

  </table>
</div>

<div
  *ngIf="!rows.length"
  class="fw-bold fs-6 text-center"
>
  <ng-container *ngIf="noDataTemplate" [ngTemplateOutlet]="noDataTemplate"></ng-container>
  <span *ngIf="!noDataTemplate">
    {{ 'COMMON.TABLE.EMPTY' | translate }}
  </span>
</div>

<ng-content></ng-content>
